// src/MentionNode.tsx
import { NodeKey, SerializedTextNode, TextNode } from "lexical";

export type SerializedMentionNode = SerializedTextNode & {
  type: "mention";
  version: 1;
  value: string;
};

export class MentionNode extends TextNode {
  private readonly __value: string;

  static getType(): string {
    return "mention";
  }

  static clone(node: MentionNode): MentionNode {
    // Create a new node without applying mode and style in the constructor
    const clone = new MentionNode(node.__value, node.__key);
    // Return the cloned node as is, without additional processing
    return clone;
  }

  constructor(value: string, key?: NodeKey) {
    // Pass the formatted text to TextNode constructor
    const textContent = `@${value} `;
    super(textContent, key);
    this.__value = value;

    // Only apply token mode and styling if this is not a clone operation
    // We can detect a clone operation because it passes a key
    if (!key) {
      // Apply styling directly after construction
      super.setMode("token");
      super.setStyle("font-weight:bold;color:#4f52b2;"); // FluentUI:colorBrandForegroundLink
    }
  }

  // Ensure the node is deletable with backspace
  isSimpleText(): boolean {
    return false;
  }

  // DOM updates not needed
  updateDOM(): boolean {
    return false;
  }

  // Include value when serializing
  exportJSON(): SerializedMentionNode {
    return {
      ...super.exportJSON(),
      type: "mention",
      version: 1,
      value: this.__value,
    };
  }
}

export function $createMentionNode(value: string): MentionNode {
  return new MentionNode(value);
}

export function $isMentionNode(node: unknown): node is MentionNode {
  return node instanceof MentionNode;
}
